import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomStepsComponent } from './custom-steps.component';
import { RouterLink } from '@angular/router';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';



@NgModule({
  declarations: [
    CustomStepsComponent
  ],
  imports: [
    CommonModule,
    RouterLink,
    ButtonModule

  ],
  exports: [
    CustomStepsComponent
  ]
})
export class CustomStepsModule { }
